import { LogErrors } from './../LogErrors'


let listeners = [] // Para poder removerlos luego

// /**
//  * Función para detectar inyección SQL (ejemplo básico)
//  * @param {string} value 
//  * @returns 
//  */
// const ValidateSqlInjection = (value, isEmail = false) => {
//     try {
//         if (isEmail) {
//             //Agregar lógica para validar el email
//             return true
//         } else {
//             const sqlInjectionKeywords = ['SELECT', 'INSERT', 'UPDATE', 'DELETE', 'DROP', ';', '--']
            
//             return sqlInjectionKeywords.some(keyword => value.toUpperCase().includes(keyword))
//         }
//     } catch (error) {
//         LogErrors('ValidateSqlInjection - BL Security', error)
//     }
// }

// /**
//  * Detecta intentos básicos de Inyección SQL en una cadena de texto.
//  * Utiliza Regex para buscar patrones peligrosos comunes.
//  * * @param {string} value - El texto a validar.
//  * @returns {Promise<boolean>} - True si se detecta una amenaza, False si es seguro.
//  */
// const ValidateSqlInjection = async (value) => {
//     try {
//         if (!value) return false;

//         const upperValue = value.toUpperCase();

//         // 1. Lista de palabras clave reservadas de SQL que no deberían estar en un mensaje normal
//         // Se buscan palabras completas para evitar falsos positivos (ej: "INSERTAR" contiene "INSERT")
//         const sqlKeywords = [
//             'DROP TABLE', 'DELETE FROM', 'INSERT INTO', 'UPDATE ', 'TRUNCATE TABLE', 
//             'ALTER TABLE', 'EXEC(', 'EXECUTE(', 'UNION ALL', 'UNION SELECT'
//         ];

//         // 2. Caracteres peligrosos comunes en ataques (comentarios, terminadores)
//         // El punto y coma (;) es peligroso si se usa para encadenar comandos.
//         // Los guiones dobles (--) se usan para comentar el resto de la query.
//         const dangerousCharacters = [';', '--', '/*'];

//         // Verificación 1: Palabras clave compuestas
//         const hasKeyword = sqlKeywords.some(keyword => upperValue.includes(keyword));

//         // Verificación 2: Caracteres de control
//         const hasDangerousChars = dangerousCharacters.some(char => value.includes(char));

//         // Verificación 3: Patrón común de ataque booleano (ej: "OR 1=1")
//         const hasBooleanAttack = /\bOR\s+\d+=\d+/i.test(value);

//         return hasKeyword || hasDangerousChars || hasBooleanAttack;

//     } catch (error) {
//         console.error("Error en ValidateSqlInjection:", error);
//         // En caso de error en la validación, por seguridad asumimos que es peligroso (Fail Safe)
//         return true; 
//     }
// };

/**
 * Detecta intentos básicos de Inyección SQL en una cadena de texto.
 * @param {string} value - El texto a validar.
 * @returns {boolean} - True si se detecta una amenaza, False si es seguro.
 */
const ValidateSqlInjection = (value) => {
    try {
        if (!value) return false;

        // 1. Lista de palabras clave reservadas compuestas.
        // Usamos \b para indicar "límites de palabra". 
        // Así evitamos que bloquee si alguien escribe una palabra que casualmente contenga esas letras.
        const sqlKeywordsRegex = /\b(DROP TABLE|DELETE FROM|INSERT INTO|UPDATE\s|TRUNCATE TABLE|ALTER TABLE|EXEC\s*\(|EXECUTE\s*\(|UNION ALL|UNION SELECT)\b/i;

        // 2. Caracteres peligrosos. 
        // Quitamos el ';' porque es puntuación válida en un texto descriptivo.
        // Mantenemos '/*' que es el inicio de un bloque de comentarios SQL.
        const dangerousCharacters = ['/*'];

        // Verificación 1: Palabras clave compuestas
        const hasKeyword = sqlKeywordsRegex.test(value);

        // Verificación 2: Caracteres de control estrictos
        const hasDangerousChars = dangerousCharacters.some(char => value.includes(char));

        // Verificación 3: Patrón común de ataque booleano (ej: "OR 1=1" u "OR 'a'='a'")
        const hasBooleanAttack = /\bOR\s+[\w']+\s*=\s*[\w']+/i.test(value);

        // Verificación 4: Comentarios SQL de guión doble.
        // En lugar de prohibir '--' en cualquier lado, lo prohibimos si está seguido de un espacio, 
        // que es como funciona el comentario en SQL (ej: "-- DROP"). Esto permite "Escuela--Sede".
        const hasDashComment = /--\s/.test(value);

        return hasKeyword || hasDangerousChars || hasBooleanAttack || hasDashComment;

    } catch (error) {
        console.error("Error en ValidateSqlInjection:", error);
        // Fail Safe: si la función falla, asumimos peligro para proteger la app
        return true; 
    }
};





// /**
//  * Bloquear retroceso y recarga de página web
//  */
// const BlockNavigation = () => {
//     try {
//         window.history.pushState(null, '', window.location.href)
//         window.onpopstate = () => {
//             window.history.pushState(null, '', window.location.href)
//         }
//         window.addEventListener('beforeunload', (e) => {
//             e.preventDefault()
//             e.returnValue = ''
//         })
//     } catch (error) {
//         LogErrors('BlockNavigation - BL Security', error)
//     }
// }

// /**
//  * Detectar cambio de pestaña/ventana
//  * @param {object} callback 
//  */
// const DetectTabChange = (callback) => {
//     try {
//         const handleVisibility = () => {
//             if (document.hidden) {
//                 callback && callback()
//             }
//         }
//         document.addEventListener('visibilitychange', handleVisibility)
//     } catch (error) {
//         LogErrors('DetectTabChange - BL Security', error)
//     }
// }

// /**
//  * Bloquear F12 y combinaciones comunes para abrir DevTools
//  */
// const BlockDevTools = () => {
//     try {
//         const keyHandler = (e) => {
//             if (
//                 e.key === 'F12' ||
//                 (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key))
//             ) {
//                 e.preventDefault()
//             }
//         }
//         document.addEventListener('keydown', keyHandler)
//         window.addEventListener('contextmenu', e => e.preventDefault())
//     } catch (error) {
//         LogErrors('BlockDevTools - BL Security', error)
//     }
// }

// /**
//  * Bloquear selección de texto, copiar y cortar
//  */
// const BlockTextSelection = () => {
//     try {
//         document.addEventListener('selectstart', e => e.preventDefault())
//         document.addEventListener('copy', e => e.preventDefault())
//         document.addEventListener('cut', e => e.preventDefault())    
//     } catch (error) {
//         LogErrors('BlockTextSelection - BL Security', error)
//     }
// }

// /**
//  * Detectar tecla de imprimir pantalla (experimental)
//  * @param {object} callback 
//  */
// const BlockPrintScreen = (callback) => {
//     try {
//         const handler = (e) => {
//             if (e.key === 'PrintScreen') {
//                 e.preventDefault()
//                 callback && callback()
//             }
//         }
//         document.addEventListener('keydown', handler)    
//     } catch (error) {
//         LogErrors('BlockPrintScreen - BL Security', error)
//     }
// }

// /**
//  * Activar todas las restricciones
//  */
// const EnableAllRestrictions = ({ onTabChange, onScreenshot } = {}) => {
//     try {
//         BlockNavigation()
//         DetectTabChange(onTabChange)
//         BlockDevTools()
//         BlockTextSelection()
//         BlockPrintScreen(onScreenshot)
//     } catch (error) {
//         LogErrors('EnableAllRestrictions - BL Security', error)
//     }
// }

// const disableAllRestrictions = () => {
//     listeners.forEach((remove) => remove())
//     listeners = []
//   }

/** Bloquea retroceso, F5 y recarga */
const BlockNavigationAndReload = () => {
    try {
        const preventNav = (e) => {
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      
        const handleKeyDown = (e) => {
          if ( e.key === 'F5' || (e.ctrlKey && (e.key === 'r' || e.key === 'R')) || (e.metaKey && (e.key === 'r' || e.key === 'R')) || (e.ctrlKey && e.shiftKey && (e.key === 'R' || e.key === 'r')) ) {
            preventNav(e)
          }
        }
      
        window.history.pushState(null, null, window.location.href)
        const handlePopState = () => {
          window.history.pushState(null, null, window.location.href)
        }
      
        window.addEventListener('keydown', handleKeyDown)
        window.addEventListener('popstate', handlePopState)
      
        listeners.push(() => {
          window.removeEventListener('keydown', handleKeyDown)
          window.removeEventListener('popstate', handlePopState)
        })
    } catch (error) {
        LogErrors('BlockNavigationAndReload - BL Security', error)
    }
}

/**
 * Detectar retroceso (historial hacia atrás)
 * @param {*} callback 
 */
const ConfirmBeforeBackNavigation = (callback) => {
    try {
        const handleBack = (e) => {
            e.preventDefault()
            e.stopPropagation()
            
            const confirmExit = window.confirm('¡CUIDADO! Estás a punto de salir de tu examen ¿Estás seguro que deseas salir?')
    
            if (confirmExit) {
                callback?.()
                window.history.back() // si desea salir
            } else {
                window.history.pushState(null, '', window.location.href)
            }
        }
    
        window.history.pushState(null, '', window.location.href) // inicializar
        window.addEventListener('popstate', handleBack)
        listeners.push(() => window.removeEventListener('popstate', handleBack))
    } catch (error) {
        LogErrors('ConfirmBeforeBackNavigation - BL Security', error)
    }
}

/** Detecta cambio de pestaña */
const DetectTabChange = (callback) => {
    try {
        const handler = () => {
            if (document.visibilityState === 'hidden') {
                callback?.()
            }
        }
        document.addEventListener('visibilitychange', handler)
        listeners.push(() => document.removeEventListener('visibilitychange', handler))      
    } catch (error) {
        LogErrors('DetectTabChange - BL Security', error)
    }
}

/** Bloquea F12 y Ctrl+Shift+I */
const BlockDevTools = () => {
    try {
        const handleKey = (e) => {
            if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i'))) {
                e.preventDefault()
            }
        }
        window.addEventListener('keydown', handleKey)
        listeners.push(() => window.removeEventListener('keydown', handleKey))      
    } catch (error) {
        LogErrors('BlockDevTools - BL Security', error)
    }
}

/** Bloquea seleccion de texto */
const BlockTextSelection = () => {
    try {
        const disableSelect = (e) => e.preventDefault()
        document.addEventListener('selectstart', disableSelect)
        listeners.push(() => document.removeEventListener('selectstart', disableSelect))
    } catch (error) {
        LogErrors('BlockTextSelection - BL Security', error)      
    }
}

/** Bloquea imprimir pantalla (no confiable pero puede disuadir) */
const BlockPrintScreen = (callback) => {
    try {
        const handleKey = (e) => {
          if (e.key === 'PrintScreen') {
            e.preventDefault()
            e.stopPropagation()
            callback?.()
          }
        }
        window.addEventListener('keydown', handleKey)
        listeners.push(() => window.removeEventListener('keydown', handleKey))      
    } catch (error) {
        LogErrors('BlockPrintScreen - BL Security', error)
    }
}

/**
 * Bloquear menú contextual
 */
const BlockContextMenu = () => {
    try {
        const handleContextMenu = (e) => e.preventDefault()
        document.addEventListener('contextmenu', handleContextMenu)
        listeners.push(() => document.removeEventListener('contextmenu', handleContextMenu))
    } catch (error) {
        LogErrors('BlockContextMenu - BL Security', error)
    }
}

/**
 * Detectar redimensionamiento
 * @param {*} callback 
 */
const DetectResize = (callback) => {
    try {
        let prevSize = {
            width: window.innerWidth,
            height: window.innerHeight
        }

        const handleResize = () => {
            if ( window.innerWidth !== prevSize.width || window.innerHeight !== prevSize.height ) {
                prevSize = {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
                callback?.()
            }
        }
        window.addEventListener('resize', handleResize)
        listeners.push(() => window.removeEventListener('resize', handleResize))
    } catch (error) {
        LogErrors('DetectResize - BL Security', error)
    }
}

// /**
//  * Evento al recargar la página
//  * @param {*} callback 
//  */
// const ConfirmBeforeReload = (callback) => {
//     try {
//         const handleBeforeUnload = (e) => {
//             e.preventDefault()
//             e.returnValue = '' // Necesario para mostrar el mensaje en la mayoría de navegadores

//             callback?.() // Aquí puedes lanzar SendNotification si el usuario acepta
//         }
//         window.addEventListener('beforeunload', handleBeforeUnload)
//         listeners.push(() => window.removeEventListener('beforeunload', handleBeforeUnload))
//     } catch (error) {
//         LogErrors('ConfirmBeforeReload - BL Security', error)
//     }
// }

/**
 * Evento al intentar cerrar la pestaña o ventana
 * @param {*} callback 
 */
const ConfirmBeforeUnload = (callback) => {
    try {
        const handleBeforeUnload = (e) => {
            e.preventDefault()
            e.returnValue = ''
            callback?.() // Ejecutar lo que necesites antes de que se cierre
            return ''
        }
    
        window.addEventListener('beforeunload', handleBeforeUnload)
        listeners.push(() => window.removeEventListener('beforeunload', handleBeforeUnload))
    } catch (error) {
        LogErrors('ConfirmBeforeUnload - BL Security', error)
    }
}

/**
 * Bloquea todos los eventos para un examen (botones, eventos, etc)
 */
const EnableAllRestrictions = ({ onTabChange, onScreenshot, onResize, onBeforeUnload, onBackNavigation } = {}) => {
    try {
        BlockNavigationAndReload()
        DetectTabChange(onTabChange)
        BlockDevTools()
        BlockTextSelection()
        BlockPrintScreen(onScreenshot)    
        BlockContextMenu()
        DetectResize(onResize)
        //ConfirmBeforeReload(onBeforeUnload)
        ConfirmBeforeUnload(onBeforeUnload)
        ConfirmBeforeBackNavigation(onBackNavigation)
        console.log("✅ EnableAllRestrictions")
    } catch (error) {
        LogErrors('EnableAllRestrictions - BL Security', error)
    }
}

/**
 * Quita todas las restricciones de botones y eventos
 */
const DisableAllRestrictions = () => {
    try {
        if (listeners.length > 0) {
            console.log("✔ DisableAllRestrictions")
            listeners.forEach((remove) => remove())
            listeners = []
        }
    } catch (error) {
        LogErrors('DisableAllRestrictions - BL Security', error)
    }
}

export { ValidateSqlInjection, BlockNavigationAndReload, ConfirmBeforeBackNavigation, DetectTabChange, BlockDevTools, BlockTextSelection, BlockPrintScreen, ConfirmBeforeUnload, EnableAllRestrictions, DisableAllRestrictions };